'use client';

import cn from 'classnames';
import { ComponentRef, forwardRef, MouseEvent } from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { TabsTriggerProps } from '@/shared/ui/core/tabs/model/tabs.types';
import styles from '@/shared/ui/core/tabs/ui/tabs.module.scss';


export const TabsTrigger = forwardRef<
    ComponentRef<typeof TabsPrimitive.Trigger>,
    TabsTriggerProps
>(function TabsTrigger ({
    className,
    onClick,
    ...props
}, ref) {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);

        // Полностью подскроллить триггер в видимую область, если список скроллится
        event.currentTarget.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };

    return (
        <TabsPrimitive.Trigger
            ref={ ref }
            className={ cn(styles.trigger, className) }
            onClick={ handleClick }
            { ...props }
        />
    );
});
